module.exports = __webpack_public_path__ + "img/funktionen-konfigurieren.004e160e.svg";